// Utility functions for facility management

/**
 * Get the facility ID for the current user or return a default UUID
 * This ensures we always have a valid UUID format for API calls
 */
export const getFacilityId = (userFacilityId?: string): string => {
  // If user has a facility ID, use it
  if (userFacilityId && isValidUUID(userFacilityId)) {
    return userFacilityId;
  }
  
  // Return a consistent default UUID for development
  return '550e8400-e29b-41d4-a716-446655440000';
};

/**
 * Validate if a string is a valid UUID format
 */
export const isValidUUID = (uuid: string): boolean => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(uuid);
};

/**
 * Generate a new UUID (for development/testing purposes)
 */
export const generateUUID = (): string => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};
